<div class="grid gap-2">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <span class="text-sm font-medium text-slate-800">{{ label() }}@if (required()) { <span class="text-red-600">*</span> }</span>
    <span class="flex items-center gap-2">
      @if (selected(); as level) {
        <span class="rounded-full px-3 py-0.5 text-xs font-semibold text-white" [style.background-color]="level.color">{{ level.name }}</span>
        @if (clearable() && !disabled()) {
          <button type="button" class="text-xs text-slate-500 underline" (click)="clear()">Clear</button>
        }
      } @else {
        <span class="text-xs text-slate-400">Not chosen</span>
      }
    </span>
  </div>

  <div
    class="relative h-8 touch-none select-none rounded-full outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2"
    [class.cursor-pointer]="!disabled()"
    [class.cursor-not-allowed]="disabled()"
    [class.opacity-60]="disabled()"
    role="slider"
    [attr.tabindex]="disabled() ? -1 : 0"
    [attr.aria-label]="label()"
    [attr.aria-valuemin]="0"
    [attr.aria-valuemax]="levels().length - 1"
    [attr.aria-valuenow]="selectedIndex() >= 0 ? selectedIndex() : null"
    [attr.aria-valuetext]="selected()?.name ?? 'Not chosen'"
    [attr.aria-disabled]="disabled()"
    (pointerdown)="pointerDown($event)"
    (pointermove)="pointerMove($event)"
    (pointerup)="pointerUp($event)"
    (keydown)="keyDown($event)">
    <div class="absolute inset-x-0 top-1/2 flex h-3 -translate-y-1/2 overflow-hidden rounded-full">
      @for (level of levels(); track level.id) {
        <div
          class="h-full flex-1 transition-opacity"
          [style.background-color]="level.color"
          [class.opacity-40]="selectedIndex() >= 0 && selectedIndex() !== $index"></div>
      }
    </div>
    @if (selected(); as level) {
      <div
        class="absolute top-1/2 h-7 w-7 -translate-x-1/2 -translate-y-1/2 rounded-full border-4 border-white shadow-md ring-2 ring-slate-900"
        [style.left.%]="thumbLeft()"
        [style.background-color]="level.color"></div>
    }
  </div>

  <div class="flex" aria-hidden="true">
    @for (level of levels(); track level.id) {
      <span class="flex-1 px-0.5 text-center text-[11px] leading-tight" [class.font-semibold]="selectedIndex() === $index" [class.text-slate-500]="selectedIndex() !== $index" [class.text-slate-900]="selectedIndex() === $index">{{ level.name }}</span>
    }
  </div>

  @if (showDescription() && selected()?.description; as description) {
    <p class="text-sm text-slate-600">{{ description }}</p>
  }
</div>
